<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <rect x="3.5" y="4" width="8" height="8" rx="2" :stroke="stroke || 'currentColor'" stroke-width="1.5"/>
    <rect x="8" y="7" width="8" height="8" rx="2" :stroke="stroke || 'currentColor'" stroke-width="1.5"/>
  </svg>
</template>

<script>
  export default {
    name: 'DoubleCircleIcon',
    props: {
      width: {
        type: Number,
        default: 20
      },
      height: {
        type: Number,
        default: 20
      },
      stroke: {
        type: String,
        default: null
      }
    }
  }
</script>

<style scoped></style>
